module.exports = __webpack_public_path__ + "img/7.a7e646cf.jpg";